import { RelatedAccount } from "../_modules/customers/_models/kyc-account-data";
import { Area } from "./area.model";

export class ServiceConnection {
    id: number;
    customerName: string;
    applicationNumber: string;
    accountNumber?: string | null;
    spn?: string;
    email?: string;
    phoneNumber?: string;
    area: Area;
    desctiptionOfServiceConnection?: string;
    identificationIssueDate?: string | null;
    identificationExpiryDate?: string | null;
    quantity?: string;
    amount?: string;
    dateInvoiceWasSent?: string;
    feederName?: string;
    feederNumber?: string;
    dsName?: string;
    dsNumber?: string;
    serviceType?: string;
    subServiceType?: string;
    siteVerificationId: number;
    isPaid?: boolean = true;
    relatedAccounts: RelatedAccount[];

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.customerName = data?.customerName ?? 0;
        this.applicationNumber = data?.applicationNumber ?? '';
        this.accountNumber = data?.accountNumber ?? '';
        this.spn = data?.spn ?? '';
        this.email = data?.email ?? '';
        this.identificationExpiryDate = data?.identificationExpiryDate ?? null;
        this.identificationIssueDate = data?.identificationIssueDate ?? null;
        this.phoneNumber = data?.phoneNumber ?? '';
        this.area = new Area(data?.area);
        this.desctiptionOfServiceConnection = data?.desctiptionOfServiceConnection ?? '';
        this.quantity = data?.quantity ?? '';
        this.amount = data?.amount ?? '';
        this.dateInvoiceWasSent = data?.dateInvoiceWasSent ?? '';
        this.serviceType = data?.serviceType ?? '';
        this.subServiceType = data?.subServiceType ?? '';
        this.siteVerificationId = data?.siteVerificationId ?? 0;
        this.isPaid = data?.isPaid;
        this.feederName = data?.feederName;
        this.feederNumber = data?.feederNumber;
        this.dsName = data?.dsName;
        this.dsNumber = data?.dsNumber;
        this.relatedAccounts = data?.relatedAccounts;
    }
}

export enum ProjectType {
    MAP = 1,
    NMAP = 2,
    KCG = 3
}

export interface ConfirmPaymentDataIn {
    kycId: number;
    verificationId: number;
}
